const SupportCircle = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.4167 4.58335L12.3883 7.61178M7.60743 12.3926L4.58335 15.4167M4.58335 4.58335L7.60743 7.60743M12.3883 12.3883L15.4167 15.4167M17.7084 10C17.7084 14.2572 14.2572 17.7084 10 17.7084C5.74283 17.7084 2.29169 14.2572 2.29169 10C2.29169 5.74283 5.74283 2.29169 10 2.29169C14.2572 2.29169 17.7084 5.74283 17.7084 10ZM13.5417 10C13.5417 11.956 11.956 13.5417 10 13.5417C8.04401 13.5417 6.45835 11.956 6.45835 10C6.45835 8.04401 8.04401 6.45835 10 6.45835C11.956 6.45835 13.5417 8.04401 13.5417 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)
export default SupportCircle
